var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Control } from 'react-redux-form';
import { withContext } from "../../componentWrappers";
import { Translate, t } from "../../I18N";
import { Icon } from "../../UI";
import { APIURL } from "../../config.js";

import { updateFile, deleteFile } from "../actions/actions";
import { wrapDispatch } from "../../Multireducer";
import { TocGeneratedLabel } from "../../ToggledFeatures/tocGeneration";
import { NeedAuthorization } from "../../Auth";
import { LocalForm } from "../../Forms/Form";
import { language as transformLanguage, availableLanguages } from "../../../shared/languagesList";
import { isBlobFile } from "../../../shared/tsUtils";



import { ViewDocumentLink } from "./ViewDocumentLink";














const mapDispatchToProps = (dispatch) =>
bindActionCreators({ updateFile, deleteFile }, wrapDispatch(dispatch, 'library'));
const connector = connect(null, mapDispatchToProps);

class File extends Component {


  constructor(props) {
    super(props);
    this.state = {
      editing: false
    };
    this.edit = this.edit.bind(this);
    this.cancel = this.cancel.bind(this);
    this.delete = this.delete.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  edit() {
    this.setState({ editing: true });
  }

  cancel() {
    this.setState({ editing: false });
  }

  delete() {
    this.props.mainContext.confirm({
      accept: () => {
        this.props.deleteFile(this.props.file, this.props.entity);
        this.setState({ editing: false });
      },
      title: 'Confirm deletion of file',
      message: 'Are you sure you want to delete this file?'
    });
  }

  handleSubmit(file) {
    this.props.updateFile(file, this.props.entity);
    this.setState({ editing: false });
  }

  renderDeleteButton() {
    return /*#__PURE__*/(
      _jsx("button", { type: "button", className: "btn btn-outline-danger", value: "Delete", onClick: this.delete }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "trash-alt" }), "\xA0", /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Delete")
      ));

  }

  renderFailed() {
    return /*#__PURE__*/(
      _jsx("div", { className: "file-failed" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "times" }), "\xA0", /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Conversion failed"), /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [this.props.entity] }, void 0,
      this.renderDeleteButton()
      )
      ));

  }

  renderReady() {
    const { language, filename = '' } = this.props.file;
    const { readonly } = this.props;
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("span", { className: "badge" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, language ? transformLanguage(language) || '' : '')
      ), /*#__PURE__*/
      _jsx(TocGeneratedLabel, { file: this.props.file }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "ML TOC")
      )
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("a", {
        href: `${APIURL}files/${filename}`,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "file-download btn btn-outline-secondary" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "cloud-download-alt" }), "\xA0", /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Download")
      ),
      !readonly && /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [this.props.entity] }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "file-edit btn btn-outline-success",
        onClick: this.edit }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "pencil-alt" }), "\xA0", /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Edit")
      )
      ), /*#__PURE__*/

      _jsx(ViewDocumentLink, { filename: filename, entity: this.props.entity }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "View")
      )
      )
      ));

  }

  renderView() {
    const { originalname, status } = !isBlobFile(this.props.file) ?
    this.props.file :
    { originalname: this.props.file.originalFile.name, status: 'ready' };

    return /*#__PURE__*/(
      _jsx("div", { className: "file" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "file-originalname" }, void 0, originalname),
      status === 'ready' && this.renderReady(),
      status === 'failed' && this.renderFailed(),
      status === 'processing' && /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "clock" }), "\xA0", /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Processing")
      )

      ));

  }

  renderEditing() {
    const mapProps = {
      className: ({ fieldValue }) =>
      fieldValue.submitFailed && !fieldValue.valid ? 'form-control has-error' : 'form-control'
    };
    return /*#__PURE__*/(
      _jsx(LocalForm, { onSubmit: this.handleSubmit, initialState: this.props.file, className: "file-form" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "form-group row" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "col-sm-12" }, void 0, /*#__PURE__*/
      _jsx("label", { htmlFor: "originalname" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Document Title"), "\xA0*"
      ), /*#__PURE__*/
      _jsx(Control.text, {
        validators: { required: (val) => Boolean(val && val.length) },
        className: "form-control",
        model: ".originalname",
        id: "originalname",
        mapProps: mapProps }
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "col-sm-3" }, void 0, /*#__PURE__*/
      _jsx("label", { htmlFor: "language" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Language")
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "col-sm-9" }, void 0, /*#__PURE__*/
      _jsx(Control.select, { className: "form-control", model: ".language", id: "language" }, void 0,
      availableLanguages.map((language) => /*#__PURE__*/
      _jsx("option", { value: language.ISO639_3 }, language.ISO639_3,
      language.localized_label, " (", language.label, ")"
      )
      ), /*#__PURE__*/
      _jsx("option", { value: "other" }, void 0, t('System', 'other', 'other', false))
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "col-sm-4" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "submit", className: "btn btn-outline-success" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "save" }), "\xA0", /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Save")
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "col-sm-4" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-outline-secondary",
        value: "Cancel",
        onClick: this.cancel }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "times" }), "\xA0", /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Cancel")
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "col-sm-4" }, void 0, this.renderDeleteButton())
      )
      ));

  }

  render() {
    return this.state.editing ? this.renderEditing() : this.renderView();
  }
}_defineProperty(File, "defaultProps", { updateFile: () => {}, deleteFile: () => {}, readonly: false });


export { File };
export const ConnectedFile = connector(withContext(File));